import { TenantNode } from 'contexts/TenantNodeContext';
import { useState } from 'react';

interface IProps {
	nodes: TenantNode[];
	selectedNodeIds: string[];
	onNodeToggle: (nodeId: string) => void;
}

export const TenantNodeTree = (props: IProps) => {
	const [searchTerm, setSearchTerm] = useState('');

	const filteredNodes = props.nodes.filter(
		(node) =>
			node.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
			node.children.some((child) =>
				child.name.toLowerCase().includes(searchTerm.toLowerCase())
			)
	);

	const renderNode = (node: TenantNode, level: number = 0) => {
		const isSelected = props.selectedNodeIds.includes(node.id);
		const hasChildren = node.children.length > 0;

		return (
			<div key={node.id} style={{ marginLeft: `${level * 20}px` }}>
				<div className="d-flex align-items-center mb-1">
					<input
						type="checkbox"
						className="form-check-input me-2"
						checked={isSelected}
						onChange={() => props.onNodeToggle(node.id)}
					/>
					<span className="fw-medium">{node.name}</span>
				</div>
				{hasChildren && (
					<div>{node.children.map((child) => renderNode(child, level + 1))}</div>
				)}
			</div>
		);
	};

	return (
		<div>
			<input
				type="text"
				className="form-control mb-3"
				placeholder="Search nodes..."
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
			/>
			<div className="tenant-node-tree">
				{filteredNodes.length > 0 ? (
					filteredNodes.map((node) => renderNode(node))
				) : (
					<div className="text-muted">No nodes found</div>
				)}
			</div>
		</div>
	);
};
